import React from "react";
import Topbar from "../Topbar";
import About from "./About";
import Protfolio from "./Portfolio";
import Banner1 from "./Banner1";
import Banner2 from "./Banner2";
import Counter from "./Counter";
import Contact from "../Contact";
import Footer from "../Footer";
import BannerImg from "../BannerImg";
import Projects from "./Projects";
import Blogs from "./Blogs";
import NewsAndPress from "./NewsAndPress";
import SEO from "../SEO";

export default function Main() {
  // Structured data for the home page
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "KGM Interiors - Home",
    description:
      "Explore the portfolio of Kritika Goswamy Malik, featuring residential, corporate, hospitality, and healthcare interior design projects. Design is a living canvas, reflecting the soul and stories of those who inhabit a space.",
    url: "https://kritikagoswamymalik.com/home",
    mainEntity: {
      "@type": "Organization",
      "@id": "https://kritikagoswamymalik.com/#organization",
      name: "KGM Interiors",
      description:
        "Interior design studio specializing in creating spaces that resonate with individuality through collaborative design journey",
      founder: {
        "@type": "Person",
        name: "Kritika Goswamy Malik",
        jobTitle: "Interior Designer",
        description:
          "Experienced interior designer with expertise in residential, corporate, hospitality, and healthcare projects",
      },
    },
    hasServices: [
      {
        "@type": "Service",
        name: "Residential Interior Design",
        description:
          "Custom home interior design services focusing on functionality and aesthetics",
      },
      {
        "@type": "Service",
        name: "Corporate Interior Design",
        description:
          "Office and corporate space design with layout optimization",
      },
      {
        "@type": "Service",
        name: "Hospitality Interior Design",
        description: "Hotel and restaurant interior design services",
      },
      {
        "@type": "Service",
        name: "Healthcare Interior Design",
        description:
          "Medical facility and healthcare space design with focus on well-being",
      },
    ],
  };

  return (
    <>
      <SEO
        title="Home - Portfolio & Services"
        description="Explore the portfolio of Kritika Goswamy Malik, featuring residential, corporate, hospitality, and healthcare interior design projects. Design is a living canvas, reflecting the soul and stories of those who inhabit a space."
        keywords="portfolio showcase, interior design services, residential projects, corporate interiors, hospitality design, healthcare design, design philosophy, space planning"
        canonicalUrl="/home"
        structuredData={structuredData}
      />

      <Topbar />
      <About />
      <Protfolio />
      <Banner1 />
      <Counter />
      <Projects />
      <Blogs />
      <Banner2 />
      <NewsAndPress />
      <Contact />
      <BannerImg />
      <Footer />
    </>
  );
}
